import { Component, OnDestroy, OnInit, input, inject } from '@angular/core';
import {RouterModule} from '@angular/router';
import {ECustomerOrganizationStatus} from '@app/shared/enums/header.enum';
import {IProductAttribute} from '@app/shared/models/product.model';
import {PrimeNgModule} from '@app/shared/modules/prime-ng/prime-ng.module';
import {selectCustomerOrganizationStatus, selectCustomerRole} from '@app/shared/state/header/header.selector';
import {environment} from '@environments/environment';
import {Store} from '@ngrx/store';
import {TranslateModule} from '@ngx-translate/core';
import {CardModule} from 'primeng/card';
import {Subject, takeUntil, tap} from 'rxjs';

@Component({
  selector: 'app-service-card-title',
  imports: [CardModule, RouterModule, TranslateModule, PrimeNgModule],
  template: ` <div class="card-title-container" (mouseenter)="showButton = true" (mouseleave)="showButton = false">
    <div class="card-title">
      <p class="m-0 pr-2">
        <ng-content />
      </p>
      @if (!showButton || isManager) {
        <span class="pi pi-circle" style="color: $primaryColor;"> </span>
      }
      @if (showButton && !isManager) {
        <p-button
          [disabled]="!productAttribute().isActive || isOrderCreating()"
          [styleClass]="
            isLiteAccount || !productAttribute().isActive
              ? 'p-button-sm p-button-rounded p-button-disabled-gray'
              : 'p-button-sm p-button-rounded p-button-outlined bg-white'
          "
          class="p-2"
          label="{{ 'Tests.Order' | translate }}"
          pTooltip="{{
            isLiteAccount
              ? ('Tests.Account_Lite_Tooltip_Message' | translate)
              : !productAttribute().isActive
                ? ('Order.InactiveOrderItem' | translate)
                : ''
          }}"
          tooltipPosition="top" />
      }
    </div>
    @if (showGeneContent()) {
      <div class="gene-content" [class.show-title-content]="showGeneContent()">
        {{ productAttribute().geneContent }}
      </div>
    }
    @if (productAttribute().description) {
      <div class="show-title-content text-justify font-italic">
        {{ productAttribute().description }}
      </div>
    }
  </div>`,
})
export class ServiceCardTitleComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);

  readonly productAttribute = input.required<IProductAttribute>();
  readonly showGeneContent = input.required<boolean>();
  readonly isOrderCreating = input.required<boolean>();
  showButton = false;
  isLiteAccount = false;
  isManager = false;
  private readonly managerRoleId = Number(environment.managerRoleId);

  private readonly unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.initCustOrgStatus();
    this.initCustRole();
  }

  private initCustOrgStatus(): void {
    this.store
      .select(selectCustomerOrganizationStatus)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap(accStatus => {
          this.verifyIsLiteAccount(accStatus);
        })
      )
      .subscribe();
  }

  private initCustRole() {
    this.store
      .select(selectCustomerRole)
      .pipe(
        tap(custRoleId => {
          this.isManager = custRoleId !== undefined && custRoleId === this.managerRoleId;
        })
      )
      .subscribe();
  }

  private verifyIsLiteAccount(accountStatus: ECustomerOrganizationStatus): void {
    this.isLiteAccount = accountStatus === ECustomerOrganizationStatus.New;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
